import { render, staticRenderFns } from "./AddMaterialSlot.vue?vue&type=template&id=f33a82fa&scoped=true"
import script from "./AddMaterialSlot.vue?vue&type=script&lang=ts"
export * from "./AddMaterialSlot.vue?vue&type=script&lang=ts"
import style0 from "./AddMaterialSlot.vue?vue&type=style&index=0&id=f33a82fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33a82fa",
  null
  
)

export default component.exports